import { render } from "./ManageFDs.vue?vue&type=template&id=3c02a3bb"
import script from "./ManageFDs.vue?vue&type=script&lang=js"
export * from "./ManageFDs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__